import {defineAbilityConfig} from '../system/defineAbilityConfig';

export const canAccessThemePanel = defineAbilityConfig([
  {
    abilities: {canDesign: true},
    features: {aiSiteGen: true},
    siteModes: {design: true},
    userTypes: {authorizedInDesigner: true},
    workflows: {canvas: true},
  },
  {
    features: {aiSiteGen: true},
    siteModes: {design: true},
    userTypes: {authorizedInDesigner: true},
    workflows: {webApps: true},
  },
  {
    // Campaign Build Mode - allow theme panel in edit mode
    abilities: {isInCampaignBuildMode: true},
    workflows: {canvas: true},
  },
  {
    // AISB Build Mode - allow theme panel + layout swapper in edit mode
    abilities: {isInAisbBuildMode: true},
    workflows: {canvas: true},
  },
] as const);
